import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '@/components/ui/dialog';
import { labels } from '@/locales/en.label';
import type React from 'react';
import { useState } from 'react';
import { useUserConnectionLogs } from '../../hooks/use-users-list';
interface ViewUserLogsProps {
	children: React.ReactNode;
	oktaId: string;
}
export function ViewUserLogs({ children, oktaId }: ViewUserLogsProps) {
	const [open, setOpen] = useState(false);
	const { userLogs: logs = [] } = useUserConnectionLogs(oktaId);

	return (
		<Dialog open={open} onOpenChange={setOpen}>
			<DialogTrigger asChild>{children}</DialogTrigger>
			<DialogContent className='tw-max-w-3xl tw-max-h-[90vh] tw-overflow-y-auto'>
				<DialogHeader>
					<DialogTitle>{labels.admin.user_table.modal.logs.header}</DialogTitle>
				</DialogHeader>
				<div className='tw-border p-4 tw-rounded-md tw-max-h-[65vh] tw-overflow-auto'>
					{logs?.length === 0 ? (
						<div>No Logs</div>
					) : (
						logs.map((log: any, index: string | number) => (
							<pre
								key={index}
								className='tw-whitespace-pre-wrap tw-break-words tw-text-xs tw-font-mono'
							>
								{log?.data
									? (() => {
											try {
												return JSON.stringify(JSON.parse(log.data), null, 2);
											} catch {
												return log.data;
											}
										})()
									: 'No Data Available'}
							</pre>
						))
					)}
				</div>
			</DialogContent>
		</Dialog>
	);
}
